import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";

export const resourcePageSettingsRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "resources/$resourcePageId",
}).lazy(() => import("./ResourcePageSettings.lazy").then((d) => d.Route));
